import { Ability } from 'providers/casl'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { USER_FRAGMENT } from '../fragments/user'
import { SignInData, SignInVars } from '../types/signIn'

export const SIGN_IN = (ability: Ability): TypedDocumentNode<SignInData, SignInVars> => gql`
  ${USER_FRAGMENT(ability)}
  ${ERROR_FRAGMENT}

  mutation signIn($email: String!, $password: String!) {
    signIn(input: { email: $email, password: $password }) {
      accessToken
      refreshToken

      user {
        ...UserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
